export default __webpack_public_path__ + "static/media/bookmark.d86834e5.svg";